import { Component, inject, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
  AuthorizationsApiClientService,
  NIASBizAPIDtosRequestRejectAuthorizationRequest,
  NIASBizBllModelsAuthDocumentInfo,
} from '../../../../../../../core/src/lib/api/v1';
import { FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { AlertService } from '../../../../../../../core/src/lib/components/alert/alert.service';
import { SupervisorAuthorisationsRoute } from '../../../../../../../core/src/lib/constants/routes.constant';

@Component({
  selector: 'app-authorisation-reject',
  imports: [
    NzIconModule,
    CommonModule,
    NzFormModule,
    ReactiveFormsModule,
    NzGridModule,
    FormsModule,
    RouterLink,
    RouterModule,
  ],
  templateUrl: './authorisation-reject.component.html',
  styleUrl: './authorisation-reject.component.scss',
})
export class AuthorisationRejectComponent {
  authDocumentInfo: NIASBizBllModelsAuthDocumentInfo;
  authDocumentId: string | null = null;
  private fb = inject(NonNullableFormBuilder);
  private alertService: AlertService = inject(AlertService);
  supervisorMenuPageRoute = SupervisorAuthorisationsRoute;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.authDocumentId = params.get('id');
      this.authorisationsApiClientService
        .authorizationsApiGetDocumentInfo(this.authDocumentId!, false)
        .subscribe((x) => {
          this.authDocumentInfo = x;
        });
    });
  }

  isNullOrWhitespace(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  private authorisationsApiClientService = inject(AuthorizationsApiClientService);
  rejectAuthorizationDocumentForm = this.fb.group({
    rejectReason: this.fb.control('', [Validators.required]),
  });

  rejectAuthorizationDocument() {
    let isWhiteSpace = this.isNullOrWhitespace(this.rejectAuthorizationDocumentForm.get('rejectReason')!.value);
    if (isWhiteSpace) {
      this.alertService.open('error', 'Razlog ne smije biti prazno polje!');
      return;
    }
    if (this.rejectAuthorizationDocumentForm.invalid || isWhiteSpace) {
      return;
    }

    var rejectRequest: NIASBizAPIDtosRequestRejectAuthorizationRequest = {
      DocumentGuid: this.authDocumentInfo.AuthDocumentId,
      RejectReason: '',
    };

    if (this.rejectAuthorizationDocumentForm.get('rejectReason')) {
      rejectRequest.RejectReason = this.rejectAuthorizationDocumentForm.get('rejectReason')!.value;
    }

     this.authorisationsApiClientService.authorizationsApiRejectRepresentation(rejectRequest).subscribe((x) => {
       this.router.navigate(['/authorisations-page-supervisor']);
     });
         this.alertService.open('success', "Odbacili ste dokument.");

  }

  cancelReject(event: MouseEvent){
    event.preventDefault();
    this.router.navigate(['/authorisations-page-supervisor']);
  }
}
